<div class="fullcontainer pr-3">
  <div class='sheet'>
    <div class='titleContainer'>
      <h1 class='header'>Report - Slow Moving Stock</h1>
      <div>
        <button class='btn btn-secondary' routerLink='/warehousing/reports'>All Reports</button>
      </div>
    </div>

    <p class='text-muted'>
      Stock currently held that has had no real movement — a goods-in, goods-out, transfer or
      adjustment — in at least the number of days below. A revaluation does not count as a
      movement: money changing without stock changing must not reset the clock on a shelf
      nothing has touched. Nothing here is enforced or fixed automatically — it names stock
      worth a decision (write it down, move it, discount it) and leaves the decision to a person.
    </p>

    <div class='row'>
      <div class='col-md-3'>
        <label>Warehouse</label>
        <select class='form-control' (change)='this.onWarehouseChanged($event.target.value)'>
          <option value='-1'>All warehouses</option>
          @for (item of this.warehouses; track item.id) {
            <option [value]='item.id'>{{ item.name }}</option>
          }
        </select>
      </div>
      <div class='col-md-3'>
        <label>Location</label>
        <!-- Locations are scoped by warehouseId and the same aisle/shelf can exist at two sites,
             so this stays disabled until a warehouse is chosen. -->
        <select class='form-control'
          [disabled]='this.selectedWarehouseId === -1'
          [(ngModel)]='this.selectedLocationId'>
          <option [value]='-1'>All locations</option>
          @for (item of this.locations; track item.id) {
            <option [value]='item.id'>{{ item.aisle }} / {{ item.shelf }}</option>
          }
        </select>
      </div>
      <div class='col-md-3'>
        <label>Product</label>
        <select class='form-control' [(ngModel)]='this.selectedProductId'>
          <option [value]='-1'>All products</option>
          @for (item of this.products; track item.id) {
            <option [value]='item.id'>{{ item.name }}</option>
          }
        </select>
      </div>
      <div class='col-md-3'>
        <label>No movement for at least (days)</label>
        <input type='number' min='0' step='1' class='form-control'
          [class.is-invalid]='this.daysInvalid'
          [(ngModel)]='this.days' />
        @if (this.daysInvalid) {
          <div class='invalid-feedback d-block'>Days must be a whole number of zero or more.</div>
        }
      </div>
    </div>
    <br />
    <br />
    <button class='btn btn-primary' (click)='this.loadReport()' [disabled]='this.running || this.daysInvalid'>Run Report</button>
    <hr />
    <button class='btn btn-secondary' (click)='exportToCSV()' [disabled]='this.result.rows.length === 0'>Export to CSV</button>
  </div>

  <div class='sheet'>
    @if (this.running) {
      <p class='m-0'><i class="fas fa-spinner fa-spin"></i> Running&hellip;</p>
    }

    @if (this.loadFailed) {
      <div class='alert alert-danger mb-0'>
        <strong>The report could not be run.</strong>
        {{ this.loadError }}
        <button class='btn btn-sm btn-danger ml-2' (click)='this.loadReport()'>Try again</button>
      </div>
    }

    @if (this.hasRun && !this.running && !this.loadFailed) {
      <div class='titleContainer'>
        <h1 class='header'>Results</h1>
      </div>

      @if (this.result.rows.length === 0) {
        <div class='alert alert-success'>
          <strong>Nothing has been sitting for {{ this.result.thresholdDays }}+ days.</strong>
          Every holding in scope has moved more recently than that.
        </div>
      }

      @if (this.result.rows.length > 0) {
        <div class='alert alert-warning'>
          <strong>{{ this.result.total }} holding(s) have had no real movement in at least
          {{ this.result.thresholdDays }} day(s).</strong>
          Oldest first. This is informational, not a control — nothing stops these being sold,
          moved or written off, and nothing here does any of that for you.
        </div>

        <table class='table'>
          <thead>
            <th>Product</th>
            <th>SKU</th>
            <th>Warehouse</th>
            <th>Aisle</th>
            <th>Shelf</th>
            <th class='text-right'>Qty</th>
            <th>Last Movement</th>
            <th class='text-right'>Days Since</th>
            <th></th>
          </thead>
          <tbody>
            @for (row of this.result.rows; track row.productId + '-' + row.warehouseLocationId) {
              <tr [class.table-danger]='this.neverMoved(row)'>
                <td>{{ row.productName }}</td>
                <td>{{ row.sku }}</td>
                <td>{{ row.warehouseName }}</td>
                <td>{{ row.aisle }}</td>
                <td>{{ row.shelf }}</td>
                <td class='text-right'>{{ this.formatQty(row.ledgerQty) }}</td>
                <!-- Blank rather than a date is wrong here; "never" is a stronger word than a very
                     old date and this is the one report where that difference is the point. -->
                <td>
                  @if (this.neverMoved(row)) {
                    <strong class='text-danger'>Never moved</strong>
                  } @else {
                    {{ this.formatDateTime(row.lastMovementAt) }}
                  }
                </td>
                <td class='text-right'>
                  @if (!this.neverMoved(row)) {
                    {{ row.daysSinceLastMovement }}
                  }
                </td>
                <td>
                  <button class='btn btn-warning'
                    routerLink='/warehousing/reports/movement-history'
                    [queryParams]='{productId: row.productId}'>Audit trail</button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    }
  </div>
</div>
